import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/home/index.vue')
  },
  {
    path: '/knowledge',
    name: 'Knowledge',
    component: () => import('@/views/knowledge/index.vue')
  },
  {
    path: '/knowledge/:type/:id',
    name: 'KnowledgeDetail',
    component: () => import('@/views/knowledge/detail.vue')
  },
  {
    path: '/resources',
    name: 'Resources',
    component: () => import('@/views/resources/index.vue')
  },
  {
    path: '/resources/preview',
    name: 'ResourcePreview',
    component: () => import('@/views/resources/preview.vue')
  },
  {
    path: '/resources/:id',
    name: 'ResourceDetail',
    component: () => import('@/views/resources/detail.vue')
  },
  {
    path: '/exhibition',
    name: 'Exhibition',
    component: () => import('@/views/exhibition/index.vue')
  },
  {
    path: '/exhibition/:id',
    name: 'ExhibitionDetail',
    component: () => import('@/views/exhibition/detail.vue')
  },
  {
    path: '/search',
    name: 'Search',
    component: () => import('@/views/search/index.vue')
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('@/views/profile/index.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes
})

export default router
